'use client'

import styled from 'styled-components'

export const BottomNavigationWrapper = styled.div`
  background-color: #ffffff;
  display: flex;
  box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.25);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3.4375rem;
  z-index: 99;
`
